import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import DesignCard from "../DesignCard";
import { useCatalog } from "../../context/CatalogContext";

/**
 * Renders admin-curated "Exclusive" designs. Hidden entirely when the admin
 * has not flagged any design as exclusive (so the section never looks empty).
 */
export default function ExclusiveCollection() {
  const { exclusiveDesigns } = useCatalog();
  if (!exclusiveDesigns || exclusiveDesigns.length === 0) return null;

  return (
    <section className="excl">
      <div className="wrap">
        <motion.div
          className="excl-head"
          initial={{ opacity: 0, y: 18 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          viewport={{ once: true, amount: 0.3 }}
        >
          <div>
            <span className="excl-eyebrow">Exclusive Collection</span>
            <h2>Reserved for you.</h2>
            <p>
              A handpicked selection you won&apos;t find in the regular
              catalogue.
            </p>
          </div>
          <Link to="/wishlist" className="excl-link">
            View Wishlist <ArrowRight size={14} />
          </Link>
        </motion.div>

        <div className="excl-grid">
          {exclusiveDesigns.slice(0, 8).map((d, i) => (
            <motion.div
              key={d.id}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.55, delay: (i % 4) * 0.08 }}
              viewport={{ once: true, amount: 0.15 }}
            >
              <DesignCard design={d} />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
